import {Component, Input, inject} from '@angular/core';
import {EventsManager} from '../../events/events.manager';
import {DataService} from '../../services/data.service';

@Component({
  selector: 'app-legal-text',
  templateUrl: './legal-text.component.html',
  styleUrls: ['./legal-text.component.scss'],
  standalone: false
})

export class LegalTextComponent {
  @Input() public officeData: any = {};
  @Input() public adminFee: number = 0;

  public eventsManager: EventsManager = inject(EventsManager);
  public dataService: DataService = inject(DataService);

  public get templateName(): string {
    if (this.officeData && this.officeData.benefitPlanTemplates && this.officeData.benefitPlanTemplates.length > 0) {
      return this.officeData?.benefitPlanTemplates[0]?.name;
    }
    return '';
  }
}
